import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { getSessionStorageItem } from "../SessionStorageMethod/getSessionStorageItem";

// Applicant flow (submit)
export function PublicApplicantRoute({ children }: any) {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const token = getSessionStorageItem("applicantToken");
  const isAuthenticated = Boolean(token);
  return isAuthenticated ? (
    <Navigate to={`/${currentLanguage}/submitassessment`} />
  ) : (
    <>{children}</>
  );
}

// Applicant flow (submit)
export function PrivateApplicantRoute({ children }: any) {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const token = getSessionStorageItem("applicantToken");
  const isAuthenticated = Boolean(token);
  return isAuthenticated ? (
    <>{children}</>
  ) : (
    <Navigate to={`/${currentLanguage}/applicantLogin`} />
  );
}

// Company flow (submit)
export function PublicAdminRoute({ children }: any) {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const token = localStorage.getItem("adminAccessToken");
  // const tempUniqueId = localStorage.getItem("tempUniqueId");
  const isAuthenticated = Boolean(token);
  return isAuthenticated ? (
    <Navigate to={`/${currentLanguage}/company-list`} />
  ) : (
    <>{children}</>
  );
}

// Company flow (submit)
export function PrivateAdminRoute({ children }: any) {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const token = localStorage.getItem("adminAccessToken");
  const isAuthenticated = Boolean(token);
  return isAuthenticated ? (
    <>{children}</>
  ) : (
    <Navigate to={`/${currentLanguage}/Login`} />
  );
}
